/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Teachingsubjects_Subject_Chemistry17Inputs */

const en__field__enum_teachingsubjects_subject_chemistry17 = /** @type {(inputs: _Field__Enum_Teachingsubjects_Subject_Chemistry17Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chemistry`)
};

const de__field__enum_teachingsubjects_subject_chemistry17 = /** @type {(inputs: _Field__Enum_Teachingsubjects_Subject_Chemistry17Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chemie`)
};

/**
* | output |
* | --- |
* | "Chemistry" |
*
* @param {_Field__Enum_Teachingsubjects_Subject_Chemistry17Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_teachingsubjects_subject_chemistry17 = /** @type {((inputs?: _Field__Enum_Teachingsubjects_Subject_Chemistry17Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Teachingsubjects_Subject_Chemistry17Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_teachingsubjects_subject_chemistry17(inputs)
	return de__field__enum_teachingsubjects_subject_chemistry17(inputs)
});
export { _field__enum_teachingsubjects_subject_chemistry17 as "_field__enum_teachingSubjects_SUBJECT_CHEMISTRY" }